import { IFulfillment, LearningType } from '../../../../features/reports/learning/common/interfaces';
import { IGroupContent } from './interfaces';

export interface IGroupsFulfillment {
  completed: number;
  total: number;
}

interface IComputeGroupsFulfillmentParams {
  fulfillments: IFulfillment[];
  // username -> studentGroupId, enabled students only (usersSlice.groupIdStudent)
  groupIdPerStudent: { [username: string]: string };
  groupsContents: IGroupContent;
  groupsIds: string[];
  learningType: LearningType;
}

// "Completed / expected" over a set of groups, with numerator and
// denominator drawn from the same population: the denominator is each
// group's enabled students x that group's current contents, so the
// numerator only counts (student, content) pairs that are in that set -
// enabled students, in one of the groups, for a content the group
// currently has - each pair once. The per-company aggregate the backend
// returns doesn't filter by any of that (it includes disabled students,
// sums duplicate Progress documents and counts contents the group no
// longer has), which is what pushed the course indicator above 100%.
export const computeGroupsFulfillment = ({
  fulfillments,
  groupIdPerStudent,
  groupsContents,
  groupsIds,
  learningType,
}: IComputeGroupsFulfillmentParams): IGroupsFulfillment => {
  const groups = new Set(groupsIds);
  let total = 0;
  groups.forEach(groupId => {
    const groupContents = groupsContents[groupId];
    if (!groupContents) {
      return;
    }
    total += groupContents.students * new Set(groupContents[learningType]).size;
  });

  const completedPairs = new Set<string>();
  fulfillments.forEach(fulfillment => {
    if (fulfillment.completed <= 0) {
      return;
    }
    const groupId = groupIdPerStudent[fulfillment.username];
    if (!groupId || !groups.has(groupId) || !groupsContents[groupId]) {
      return;
    }
    if (!groupsContents[groupId][learningType].includes(fulfillment.id)) {
      return;
    }
    completedPairs.add(`${fulfillment.username}|${fulfillment.id}`);
  });

  return { completed: completedPairs.size, total };
};
